import { Fragment } from "react";
import { Company } from "../../../core/models/company.model";
import { IconLocation } from "../../../assets/svgs-index";
import LinkButton from "../../buttons/LinkButton/LinkButton";

const CompanyAddressInfo = (props: { company: Company | undefined, darkMode?: boolean }) => {
  const { company, darkMode } = props;

  if (!company?.address) {
    return <Fragment />;
  }

  return (
    <div className="company-info d-inline-flex">
      <div className="info-icon me-2">
        <img src={IconLocation} alt="address-icon" />
      </div>
      <div className="info-text">
        <LinkButton
          onClick={() => {}}
          styleClass="link-container"
          textClass="small"
          //icon={IconLocation}
          darkMode={darkMode}
          isMaps
          valueLink={company?.name+', '+company?.address}
          valueText={company?.address || company?.town}
        />
      </div>
    </div>
  );
}

export default CompanyAddressInfo;